module.exports = __webpack_public_path__ + "static/media/results-page-steps-icon.59ead41f.svg";